import { Link } from '@elements/link'
import { FacebookLogo } from '@icons/facebook'
import { InstagramLogo } from '@icons/instagram'
import { TwitterLogo } from '@icons/twitter'
import { Venue } from 'types/model'

export function VenueSocialLinks({ venue }: { venue: Venue }) {
  const { facebook, twitter, instagram } = venue.details.social ?? {}

  return (
    <nav>
      <ul className="flex items-center space-x-3">
        {facebook && (
          <li>
            <Link
              className="!text-inherit !fill-inherit"
              target="_blank"
              rel="noreferrer"
              href={facebook}
            >
              <FacebookLogo
                className="w-4 h-auto sm:w-5"
                title={`${venue.name} Facebook Profile`}
              />
            </Link>
          </li>
        )}
        {twitter && (
          <li>
            <Link
              className="!text-inherit !fill-inherit"
              target="_blank"
              rel="noreferrer"
              href={twitter}
            >
              <TwitterLogo className="w-4 h-auto sm:w-5" title={`${venue.name} Twitter Profile`} />
            </Link>
          </li>
        )}
        {instagram && (
          <li>
            <Link
              className="!text-inherit !fill-inherit"
              target="_blank"
              rel="noreferrer"
              href={instagram}
            >
              <InstagramLogo
                className="w-4 h-auto sm:w-5"
                title={`${venue.name} Instagram Profile`}
              />
            </Link>
          </li>
        )}
      </ul>
    </nav>
  )
}
